module.exports = __webpack_public_path__ + "img/logo.6928f308.svg";